import React from 'react';

import { Container } from './styles';

const Slider = ({ ...props }) => <Container {...props} />;

export default Slider;
